import { useContext } from 'react'

import { useQuery } from '@apollo/client'
import { EnvironmentContext } from 'config/environment'
import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { useCheckModuleAcquired } from 'modules/marketplace_modules/hooks/useCheckModuleAcquired'

export interface RouterState {
  location: {
    pathname: string
  }
  routes?: string[]
}

export const useGetSiteControl = () => {
  const tracker = window.gsc || (() => {})
  const {
    employee,
    access: { locale },
    company: { id: companyId, legalEntities, subscription },
    canRequestUpsell,
    canSeeProductUpdates,
  } = useCurrentSession()
  const { data } = useQuery(FeatureFlagAvailabilitiesDocument, {
    variables: {
      companyId,
      featureNames: ['do_not_track'],
    },
  })
  const doNotTrack = data?.features?.featuresConnection?.nodes[0]?.enabled ?? false
  const country = legalEntities.find(({ main }) => main)?.country ?? ''
  const isTrainingsAdquired = useCheckModuleAcquired('trainings')
  const isATSAdquired = useCheckModuleAcquired('ats')
  const isExpensesAdquired = useCheckModuleAcquired('expenses')
  const isReviewAdquired = useCheckModuleAcquired('review_process')
  const isProjectsAdquired = useFeatureAvailability('projects_budget').featureAvailability.available
  const isShiftManagementAdquired = useCheckModuleAcquired('shift_management')
  const employeeId = employee?.id
  const { skipGetSiteControl } = useContext(EnvironmentContext)

  if (skipGetSiteControl || doNotTrack) {
    return {
      identify() {},
      trackPage() {},
      trackParam() {},
    }
  }

  return {
    identify() {
      const parameters = {
        employeeId: employeeId,
        companyId,
        country,
        locale,
        canRequestUpsell,
        isTrainingsAdquired,
        isATSAdquired,
        isExpensesAdquired,
        isReviewAdquired,
        isProjectsAdquired,
        isShiftManagementAdquired,
        seatCount: subscription.seatCount,
        canSeeProductUpdates,
      }
      tracker('params', parameters)
    },
    trackPage(state: RouterState) {
      tracker('params', {
        trackPage: state.location.pathname,
      })
    },
    trackParam(name: string, value: unknown) {
      tracker('params', { [name]: value })
    },
  }
}
